(function () {
  /**
   * Check if document is ready
   * @param fn
   */
  function ready (fn) {
    if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
      fn()
    } else {
      document.addEventListener('DOMContentLoaded', fn)
    }
  }

  /**
   * Create an cookie
   * @string cookieName
   * @param cookieContent
   * @int cookieTTL
   */
  function createCookie (cookieName, cookieContent, cookieTTL) {
    var d = new Date()
    d.setTime(d.getTime() + (cookieTTL * 24 * 60 * 60 * 1000))
    var expires = 'expires=' + d.toUTCString()
    document.cookie = cookieName + '=' + cookieContent + ';' + expires + ';path=/'
  }

  /**
   * Get Cookie
   * @param cookieName
   * @return {*}
   */
  function getCookie (cookieName) {
    var name = cookieName + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }

  /**
   *
   * @string cookieName
   * @return {boolean}
   */
  function checkCookie (cookieName) {
    var cookie = getCookie(cookieName)
    return cookie !== ''
  }

  /**
   * Prepare everyting
   */
  function run () {
    // /**
    // * Cookielayer related
    // */
    // document.getElementById('cookie-layer-close').addEventListener('click', function () {
    //   createCookie('cookie-layer-close', true, 30)
    //   document.getElementById('cookie-layer').classList.add('disabled')
    // })

    // if (checkCookie('cookie-layer-close') === true) {
    //   document.getElementById('cookie-layer').classList.add('disabled')
    // }

    /**
    * Firstvisit related
    */
    if (checkCookie('visited') === true) {
      setTimeout(function () {
        document.getElementById('app').scrollIntoView(true)
      }, 500)
    } else {
      createCookie('visited', true, 60)
    }
  }

  /**
   * Run everything on ready
   */
  ready(run)
}())
